import { render, staticRenderFns } from "./Cias.vue?vue&type=template&id=6d7e237c&scoped=true"
import script from "./Cias.vue?vue&type=script&lang=js"
export * from "./Cias.vue?vue&type=script&lang=js"
import style0 from "./Cias.vue?vue&type=style&index=0&id=6d7e237c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d7e237c",
  null
  
)

export default component.exports